// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  OrientationVersion,
  OrientationStatus,
} from "./types";


export default __t.row({
  orientationId: __t.string().primaryKey().name("orientation_id"),
  projectId: __t.string().name("project_id"),
  displayName: __t.string().name("display_name"),
  occupationTarget: __t.array(__t.string()).name("occupation_target"),
  description: __t.string(),
  get status() {
    return OrientationStatus;
  },
  autoAssign: __t.bool().name("auto_assign"),
  get defaultVersion() {
    return OrientationVersion.name("default_version");
  },
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  passingScorePct: __t.option(__t.u32()).name("passing_score_pct"),
  showAnswersAtEnd: __t.bool().name("show_answers_at_end"),
  autoReassignOnFail: __t.bool().name("auto_reassign_on_fail"),
  maxAttempts: __t.option(__t.u32()).name("max_attempts"),
  createdBy: __t.string().name("created_by"),
});
